var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addingSelectionDialog" },
    [
      _c("h2", [_vm._v(_vm._s(_vm.$t("addingSelectionDialog.Adding")))]),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.$t("addingSelectionDialog.Wait")))]),
      _vm._v(" "),
      _c("dots-loader")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0432cd14", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0432cd14","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/addingSelectionsDialog.vue
// module id = null
// module chunks = 